// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"62b3f86d","389":"44846ae2","732":"238d8be2","977":"ca221bb8"}[chunkId] + ".chunk.js");